// extracted by mini-css-extract-plugin
export default {"description":"AvailableTimeForTag_description__fv3FU"};